import { jsx as _jsx } from "react/jsx-runtime";
import Head from "next/head";
// Agent/crawler discovery hint — mirrors the equivalent addition in
// server/routes/generated-pages/seo-tags.js for /gp/ pages, and in
// homepage-webflow's src/scripts/add-llms-txt-link.js for Webflow pages.
//
// Self-wraps in next/head's <Head> so it always lands in the document <head> regardless of
// where it's called from. `rel="alternate"` is not in the HTML spec's body-ok list — a caller
// that mounts outside next/head (e.g. header-scripts-component.js, which renders in the body
// alongside BigBrainScript/Polyfills) would otherwise render it as invalid, spec-violating markup.
const LlmsTxtLinkComponent = ()=>/*#__PURE__*/ _jsx(Head, {
        children: /*#__PURE__*/ _jsx("link", {
            rel: "alternate",
            type: "text/plain",
            title: "llms.txt",
            href: "/llms.txt"
        })
    });
export default LlmsTxtLinkComponent;
